import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const NotFound = () => {
  return (
    <div className="w-full bg-slate-50 min-h-[70vh] flex items-center justify-center py-20 px-4">
      <div className="text-center max-w-md">
        <div className="w-24 h-24 bg-slate-200 rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiIcons.FiAlertTriangle} className="text-4xl text-slate-500" />
        </div>
        <h1 className="text-4xl font-bold text-slate-900 mb-4">Page Not Found</h1>
        <p className="text-slate-600 mb-8">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-slate-900 text-white font-bold rounded hover:bg-slate-800 transition-colors">
          <SafeIcon icon={FiIcons.FiArrowLeft} /> Return Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;